import { createRouter, createWebHashHistory } from 'vue-router'

import store from '@/vuex/index'

// containers
import PublicPage from '@/views/publicpage'
import PrivatePage from '@/views/privatepage'

// Views
import StatusView from '@/views/privatesection/statusview'
import UserGroupView from '@/views/privatesection/usergroupview'
import UserGroupDetailView from '@/views/privatesection/usergroupdetailview'
import TestMethodView from '@/views/privatesection/testmethodview'
import TestMethodDetailView from '@/views/privatesection/testmethoddetailview'
import InstructionsView from '@/views/privatesection/instructionsview'
import InstructionsDetailView from '@/views/privatesection/instructionsdetailview'
import ScaleView from '@/views/privatesection/scaleview'
import ScaleDetailView from '@/views/privatesection/scaledetailview'
import ScaleQuestionsView from '@/views/privatesection/scalequestionsview'
import TestSuiteView from '@/views/privatesection/testsuiteview'
import MyTestMethodsView from '@/views/privatesection/mytestmethodsview'
import TestBuilderDetailView from '@/views/privatesection/testbuilderdetailview'
import NormGroupsView from '@/views/privatesection/normgroupsview'
import NormGroupsDetailView from '@/views/privatesection/normgroupsdetailview'
import MyProfileView from '@/views/privatesection/myprofileview'
import ExpertReportsView from '@/views/privatesection/expertreportsview'
import ExpertReportDetailsView from '@/views/privatesection/expertreportdetailsview'
import TestDataExportView from '@/views/privatesection/testdataexportview'

export default createRouter({
  scrollBehavior: () => ({ top: 0 }),
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'root',
      component: PublicPage
    },
    {
      path: '/private',
      name: 'admin',
      component: PrivatePage,
      children: [
        {
          path: 'myprofile',
          name: 'myprofile',
          component: MyProfileView
        },
        {
          path: 'expertreports',
          name: 'expertreports',
          component: ExpertReportsView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasSupplierPermissions) next()
            else next('/private/status')
          },
          children: [
            {
              path: 'expertreport',
              name: 'expertreport',
              component: ExpertReportDetailsView,
              beforeEnter: (to, from, next) => {
                if (store.getters.hasSupplierPermissions) next()
                else next('/private/status')
              }
            }
          ]
        },
        {
          path: 'instructions',
          name: 'instructions',
          component: InstructionsView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasSupplierPermissions) next()
            else next('/private/status')
          },
          children: [
            {
              path: 'instruction',
              name: 'instruction',
              component: InstructionsDetailView,
              beforeEnter: (to, from, next) => {
                if (store.getters.hasSupplierPermissions) next()
                else next('/private/status')
              }
            }
          ]
        },
        {
          path: 'status',
          name: 'status',
          component: StatusView
        },
        {
          path: 'usergroups',
          name: 'usergroups',
          component: UserGroupView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasResellerPermissions) next()
            else next('/private/status')
          }
        },
        {
          path: 'group',
          name: 'group',
          component: UserGroupDetailView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasResellerPermissions) next()
            else next('/private/status')
          }
        },
        {
          path: 'testmethods',
          name: 'testmethods',
          component: TestMethodView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasSupplierPermissions) next()
            else next('/private/status')
          },
          children: [
            {
              path: 'testmethod',
              name: 'testmethod',
              component: TestMethodDetailView,
              beforeEnter: (to, from, next) => {
                if (store.getters.hasSupplierPermissions) next()
                else next('/private/status')
              }
            }
          ]
        },
        {
          path: 'my-testmethods',
          name: 'my-testmethods',
          component: MyTestMethodsView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasCustomerPermissions) next()
            else next('/private/status')
          },
          children: [
            {
              path: 'testbuilder',
              name: 'testbuilder',
              component: TestBuilderDetailView,
              props: true,
              beforeEnter: (to, from, next) => {
                if (store.getters.hasCustomerPermissions) next()
                else next('/private/status')
              }
            }
          ]
        },
        {
          path: 'scales',
          name: 'scales',
          component: ScaleView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasSupplierPermissions) next()
            else next('/private/status')
          },
          children: [
            {
              path: 'scale',
              name: 'scale',
              component: ScaleDetailView,
              children: [
                {
                  path: 'questions',
                  name: 'scalequestions',
                  component: ScaleQuestionsView,
                  props: true
                }
              ]
            }
          ]
        },
        {
          path: 'testsuite',
          name: 'testsuite',
          component: TestSuiteView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasCustomerPermissions) next()
            else next('/private/status')
          }
        },
        {
          path: 'normgroups',
          name: 'normgroups',
          component: NormGroupsView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasSupplierPermissions) next()
            else next('/private/status')
          },
          children: [
            {
              path: 'normgroup',
              name: 'normgroup',
              component: NormGroupsDetailView,
              props: true,
              beforeEnter: (to, from, next) => {
                if (store.getters.hasSupplierPermissions) next()
                else next('/private/status')
              }
            }
          ]
        },
        {
          path: 'testdata',
          name: 'testdata',
          component: TestDataExportView,
          beforeEnter: (to, from, next) => {
            if (store.getters.hasSupplierPermissions) next()
            else next('/private/status')
          }
        }
      ]
    }
  ]
})
